import { getDateRange, isEmptyObject } from '@/module/util/index'


export default {
    methods: {
        getDateRange,
        isEmptyObject
    }
}
